import type { FilterableClassification, FilterableFixStatus, FilterablePatchStatus } from './filter-state-store.tsx'

/**
 * The user-facing name of every filter value across the filter UI — the dropdown filter and the
 * active filter chips — so those two cannot drift apart. The composition bars keep their own copies
 * of the same strings in `composition-bar/composition-utils.ts` and in the quick-view config; those
 * are not covered here.
 */
export const CLASSIFICATION_LABELS: Record<FilterableClassification, string> = {
  true_positive: 'True positive',
  suspicious: 'Likely true positive',
  inconclusive: 'Inconclusive',
  false_positive: 'False positive',
  wont_fix: "Won't fix",
  blocked: 'Blocked',
  excluded: 'Excluded',
  error: 'Error',
  not_triaged: 'Not triaged',
}

export const FIX_RESULT_LABELS: Record<FilterableFixStatus, string> = {
  completed: 'Available fix',
  failed: 'Error',
  'no-recommendations-available': 'No recommendations',
  blocked: 'Blocked',
  excluded: 'Excluded',
}

export const PATCH_STATUS_LABELS: Record<FilterablePatchStatus, string> = {
  issued: 'Fix issued',
  merged: 'Fix merged',
}
